import { Box, Chip, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'

export const ChipsWrapper = styled(Box)(({ theme }) => ({
  marginLeft: '8px',
  textAlign: 'center',
  display: 'inline-flex',
  alignItems: 'center',
  fontSize: '0.875rem',
  lineHeight: 1.43,
  letterSpacing: '0.01071em',
  fontFamily: theme.typography.fontFamily,
}))

export const CurrentBalanceWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  marginBottom: '4px',
})

export const AgencyPayment = styled(Box)(({ theme }) => ({
  marginTop: '8px',
  fontWeight: '300',
  fontStyle: 'italic',
  color: theme.palette.text.secondary,
}))

export const StyledChip = styled(Chip)(({ theme }) => ({
  '&.MuiChip-colorError': {
    color: theme.palette.error.main,
    backgroundColor: theme.legacyColors.ERROR_OUTLINED,
  },
}))
